export const localStorageKeys = {
  selectedBaseUrl: 'tvattmaskin.primus_baseurl',
  selectedDatabase: 'tvattmaskin.primus_database',
  selectedPrimusList: 'tvattmaskin.primus_selectedList',
  selectedPrimusListName: 'tvattmaskin.primus_selectedListName',
  isAwake: 'tvattmaskin.primus_isAwake',
  lng: 'i18nextLng'
}